module.exports = __webpack_public_path__ + "cd8261d9863c4bb79e4a7c704c3bbf8d.MP3";